import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Typography from '@mui/material/Typography';
import { getBuildTime, getGitCommit } from '../utils/versionUtils';
export const VersionDisplay = () => {
    const versionParts = [getGitCommit().toUpperCase(), getBuildTime()];
    return (_jsx("div", { css: css `
        color: #aaaaaa;
        padding: 3px;
      `, children: _jsxs(Typography, { component: 'div', variant: 'caption', children: ["VERSION: ", versionParts.join(' ')] }) }));
};
